import api from './api'; 
import API_CONFIG from '../config/api';

const doaService = {
  // GET /api/v1/doa
  getDoAConfigs: async () => {
    const response = await api.get(API_CONFIG.ENDPOINTS.DOA);
    return response.data;
  },

  // POST /api/v1/doa
  createDoAConfig: async (data) => {
    const response = await api.post(API_CONFIG.ENDPOINTS.DOA, data);
    return response.data;
  },

  // PUT /api/v1/doa/:id
  updateDoAConfig: async (id, data) => {
    const response = await api.put(`${API_CONFIG.ENDPOINTS.DOA}/${id}`, data);
    return response.data;
  },

  // GET /api/v1/roles
  getRoles: async () => {
    // Adding limit=100 to ensure we get all roles for the dropdown
    const response = await api.get(`${API_CONFIG.ENDPOINTS.ROLES}?limit=100&status=active`);
    return response.data; 
  },

  toggleDoAStatus: async (id, status) => {
    const response = await api.put(`${API_CONFIG.ENDPOINTS.DOA}/${id}`, { isActive: status });
    return response.data;
  },

  getDoAStats: async () => {
    const response = await api.get(`${API_CONFIG.ENDPOINTS.DOA}/stats`);
    return response.data;
  }
};

export default doaService;